export enum StorageFields {
    fbToken = 'FB_TOKEN',
}
